import { createSelector } from 'reselect';

export const initialState = [];

const contactTypesSelector = (state = initialState) => state.contactTypes;

export const getContactTypes = createSelector(contactTypesSelector, (contactTypes) => contactTypes);
